export const cardHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem 0.875rem',
  backgroundColor: '#f9fafb',
  borderBottom: '1px solid #f0f0f0',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px'
} as const;

export const cardContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  backgroundColor: '#FFFFFF',
  padding: '1rem',
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px'
} as const;
